import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import BookAppoiointment from './components/booking';
import { StoreProvider } from './store/StoreProvider';
import { SessionProvider } from 'hooks/SessionProvider';
import ErrorBoundary from 'components/errorBoundry';
import FullScreenAPT from 'components/booking/fullScreenMode';
import { BackendDateFormat, BookingData, CallendarDateFormat } from 'utils/constants'; //this import just used for local purpose only
import { RouteProvider } from 'hooks/RouteProvider';
import moment from 'moment';
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

const parseAndFormatDate = (currentDate: string): moment.Moment => {
  const parsedDate = moment.parseZone(currentDate, BackendDateFormat);
  return parsedDate;
};

const rootElement = document.getElementById('root') || document.getElementById('external-root');
//this can be uncomment only while project is running on local machine
// if (rootElement) {
//   const root = ReactDOM.createRoot(rootElement);
//   root.render(
//     <ThemeProvider theme={theme}>
//         <ErrorBoundary>
//           <React.StrictMode>
//             <StoreProvider>
//             <SessionProvider startDate={parseAndFormatDate(BookingData.start_datetime)}>
//             <RouteProvider> {/* Wrap the App with RouteProvider */}
//                 <App />
//               </RouteProvider>
//               </SessionProvider>
//             </StoreProvider>
//           </React.StrictMode>
//         </ErrorBoundary>
//     </ThemeProvider>
//   );
// }


window.BookingWidget = (rootElement: HTMLElement | null, data: any) => {
  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <ThemeProvider theme={theme}>
        <ErrorBoundary>
          <React.StrictMode>
            <StoreProvider>
              <SessionProvider startDate={parseAndFormatDate(data.start_datetime)}>
                <RouteProvider> {/* Wrap the App with RouteProvider */}
                  <BookAppoiointment data={data} />
              </RouteProvider>
              </SessionProvider>
            </StoreProvider>
          </React.StrictMode>
      </ErrorBoundary>
      </ThemeProvider>
    );
  } else {
    console.error('Root element not found.');
  }
};

window.FullScreenAPT = (rootElement: HTMLElement | null, Newdata: any) => {
  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <ThemeProvider theme={theme}>
        <ErrorBoundary>
          <React.StrictMode>
            <StoreProvider>
              <SessionProvider startDate={parseAndFormatDate(Newdata.start_datetime)}>
                <RouteProvider> {/* Wrap the App with RouteProvider */}
                 <FullScreenAPT data={Newdata} />
              </RouteProvider>
              </SessionProvider>
            </StoreProvider>
          </React.StrictMode>
      </ErrorBoundary>
      </ThemeProvider>
    );
  } else {
    console.error('Root element not found.');
  }
};


